/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_NotificationsInputs */

const en_settings_notifications = /** @type {(inputs: Settings_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone notifications`)
};

const he_settings_notifications = /** @type {(inputs: Settings_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות בטלפון`)
};

/**
* | output |
* | --- |
* | "Phone notifications" |
*
* @param {Settings_NotificationsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_notifications = /** @type {((inputs?: Settings_NotificationsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_NotificationsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_notifications(inputs)
	return he_settings_notifications(inputs)
});